import { Button, Upload, message } from "antd"
import { withTranslation } from "react-i18next"
import { UploadOutlined } from "@ant-design/icons"
import axios from "axios"

import { get } from "library/endpoints"
import { makeid } from "utils"

const UploadFile = (props) => {

  const uploadProps = {
    name: 'file',
    showUploadList: false,
    beforeUpload: async (uploadedfile) => {
      try {
        const clientEntry = props.client;

        const isJpgOrPng = uploadedfile.type === 'image/jpeg' || uploadedfile.type === 'image/png';

        if (!isJpgOrPng) {
          return false;
        }

        const regex = /(?:\.([^.]+))?$/;
        
        var newFileName = `${makeid(10)}-${uploadedfile.name.replace(/[^0-9a-zA-Z.]/g, '')}`;

        const file = new File([uploadedfile], newFileName)

        const response = await get(`/frontend/help-desk/signed-uri/${clientEntry._id}`, {
          type: regex.exec(file.name)[1],
          filename: file.name
        })

        const options = {
          headers: {
            'Content-Type': 'image/vnd.adobe.photoshop'
          }
        }

        axios
          .put(response.data, file, options)
          .then( async (result) => {
            props.callback(`tenants/${clientEntry._tenant}/clients/${clientEntry._id}/helpdesk/${file.name}`)
          })
          .catch((error) => {
            message.error(`${file.name} ${props.t('Helpdesk.Upload.UploadFailed', 'n a pu être ajouté')}`);
          });          
      } catch (err) {
        console.log(err)
        message.error(`${uploadedfile.name} ${props.t('Helpdesk.Upload.UploadFailed', 'n a pu être ajouté')}`);
      }
      return false;
    },
  };

  return (
    <Upload {...uploadProps}>
      <Button size="small"  icon={<UploadOutlined />}>{props.label}</Button>
    </Upload>

  )
}

export default withTranslation()(UploadFile)